<template>
  <div class="seaclaw-layout">
    <header class="global-header">
      <div class="logo-box">
        <span class="logo-icon">🌊</span>
        <span class="logo-text">SeaClaw</span>
      </div>

      <div class="header-right">
        <span style="margin-right: 15px; font-size: 14px; color: #909399">
          当前用户: {{ authStore.user?.username || "加载中..." }}
        </span>
        <div class="user-profile-btn" @click="handleLogout">
          <el-avatar :size="32" style="background: #c0c4cc">
            <el-icon><UserFilled /></el-icon>
          </el-avatar>
        </div>
      </div>
    </header>

    <div class="main-body">
      <aside class="global-sidebar">
        <nav class="nav-menu">
          <router-link
            to="/console/chat"
            class="nav-item"
            active-class="active"
          >
            <el-icon class="icon"><ChatDotRound /></el-icon>
            <span class="text">对话</span>
          </router-link>

          <router-link
            to="/console/skills"
            class="nav-item"
            active-class="active"
          >
            <el-icon class="icon"><MagicStick /></el-icon>
            <span class="text">技能</span>
          </router-link>

          <router-link
            to="/console/config"
            class="nav-item"
            active-class="active"
          >
            <el-icon class="icon"><Setting /></el-icon>
            <span class="text">配置</span>
          </router-link>

          <router-link
            to="/console/files"
            class="nav-item"
            active-class="active"
          >
            <el-icon class="icon"><Folder /></el-icon>
            <span class="text">文件</span>
          </router-link>
        </nav>
      </aside>

      <main class="main-content">
        <router-view v-slot="{ Component }">
          <transition name="fade-transform" mode="out-in">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </transition>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  UserFilled,
  ChatDotRound,
  MagicStick,
  Setting,
  Folder,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();
// 预留登出逻辑
const handleLogout = () => {
  ElMessageBox.confirm("确定要退出登录吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      authStore.clearAuth();
      router.push("/login");
      ElMessage.success("退出登录成功！");
    })
    .catch(() => {});
};
onMounted(() => {
  // 如果钱包里没数据，再去拉取（避免每次切换子路由都发请求）
  if (!authStore.user) {
    authStore.fetchUserInfo();
  }
});
</script>

<style scoped>
/* 这里只保留 Layout 的样式 (seaclaw-layout, global-header, global-sidebar 等) */
.seaclaw-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: #f5f7fa;
  margin: -8px;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
}
.global-header {
  height: 56px;
  background-color: #ffffff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 101;
  flex-shrink: 0;
}
.logo-box {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 800;
  color: #2c3e50;
  font-style: italic;
}
/* 你原代码中关于 Layout 布局的 CSS 直接贴到这里即可，篇幅原因省略 */
.header-right {
  display: flex;
  align-items: center;
}
.user-profile-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.3s;
}
.user-profile-btn:hover {
  background: #f0f2f5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.main-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.global-sidebar {
  width: 80px;
  background-color: #ffffff;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
  z-index: 100;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.02);
}
.nav-menu {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 15px 0;
  color: #909399;
  width: 100%;
  transition: all 0.3s;
}
.nav-item.active {
  color: #409eff;
  background-color: #f0f7ff;
  border-right: 3px solid #409eff;
}
.nav-item .icon {
  font-size: 24px;
  margin-bottom: 6px;
}
.nav-item .text {
  font-size: 12px;
  font-weight: 500;
}
.main-content {
  flex: 1;
  position: relative;
  height: 100%;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}
.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
